import React from 'react';
import {withRouter, Link} from 'react-router-dom';
import {Carousel, Container, Col, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleLeft, faAngleRight, faSearch, faTrash} from '@fortawesome/free-solid-svg-icons';
import {Modal, Tabs, Spin, Empty} from 'antd';
import ReportDashboard from '../../partials/ReportDashboard';
import Api from '../../../services/Api';
import UserInfo from '../../auth/UserInfo';
import EarnPoints from './home/EarnPoints';
import GiveGift from './home/GiveGift';
import animation from '../../../assets/coupon_animation.json';
import Lottie from 'react-lottie';
import HelperGeneral from '../../../helpers/HelperGeneral';
import ReactHtmlParser from "react-html-parser";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            width: window.innerWidth,
            product_data: [],
            transactions: [],
            pagination: {
                current: 1,
                pageSize: 15,
            },
            loading: true,
            productInputLoading: false,
            sliders: [],
            sliderLoading: true,
            activeKey: "1",
            pointModal: false,
            getTop5Products: false,
            getTop5SellerProducts: false,
            lastLookedItem: [],
            lastLookedItemLoading: true,
            top5Loading: true,
            placeholderItem: {
                "productId": undefined,
                "title": "-",
                "subTitle": "-",
                "barcode": "-",
                "description": "-",
                "requiredPoint": "-",
                "rewardPoint": "-",
                "quantity": "-",
                "price": "-",
                "largeImageUrl": undefined,
                "smallImageUrl": undefined,
                "giftEnable": false,
                "inStock": false,
                "productCategory": null,
                "usage": "",
                "ingredients": "",
                "warnings": "",
                "videoUrl": "",
                "skinType": null
            }
        };
        this.productAddForm = React.createRef();
        this.productInput = React.createRef();

        this.timerProductAdd = null;
    }

    updateWindowWidth = () => {
        this.setState({
            width: window.innerWidth
        });
    };

    async componentDidMount() {
        window.addEventListener('resize', this.updateWindowWidth);

        try {
            const slidersData = await Api.getAllBanner();
            const filteredData = Object.values(slidersData?.data?.sliders).find(item => item?.template?.main?.id === 7);
            this.setState({
                sliders: (filteredData?.list && filteredData?.list?.length > 0) ? filteredData.list : [],
                sliderLoading: false
            }, () => {
                try {
                    const sliders = (filteredData?.list && filteredData?.list?.length > 0) ? filteredData.list : [];
                    if (typeof window.soulTrackEvent === 'function' && sliders.length) {
                        sliders.forEach((s, idx) => {
                            window.soulTrackEvent({
                                eventName: 'view_promotion',
                                ecommerce: {
                                    creative_slot: `Home Page - Slider - ${idx + 1}`,
                                    promotion_id: String(s?.id ?? idx + 1),
                                    promotion_name: s?.title || s?.name || `slider_${idx + 1}`,
                                    promotion_image: s?.image_urls?.image?.raw ?? s?.image_urls?.image?.w750x,
                                    promotion_position: idx + 1,
                                },
                            });
                        });
                    }
                } catch (e) {
                    // best-effort
                }
            });
        } catch (e) {
            this.setState({
                sliderLoading: false
            });
        }

        this.getTop5Products();
        this.bestSeller();

        const lastLookedItemTemp = JSON.parse(localStorage.getItem('pharmacyLastLookedItems')) ?? [];
        if (lastLookedItemTemp.length === 0) {
            this.setState({lastLookedItem: [], lastLookedItemLoading: false});
        } else {
            Promise.all(
                lastLookedItemTemp.map(item =>
                    Api.getProductDetail(item?.slug)
                        .then(r => r?.data ?? item)
                        .catch(() => item)
                )
            ).then(freshItems => {
                this.setState({lastLookedItem: freshItems, lastLookedItemLoading: false});
            });
        }

        Api.getCustomer().then(r2 => {
            const {remember} = UserInfo.dataCheck();
            UserInfo.setUserInfo(r2?.data, remember);
        }).catch((e) => {
            HelperGeneral.alert(e);
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowWidth);
    }

    getTop5Products = () => {
        Api.getTop5('company_sales', UserInfo.info('company_id')).then((response) => {
            // if (response?.data?.result?.products && response?.data?.result?.products?.length > 0) {
            //     response.data.result.products = [
            //         ...response?.data?.result?.products,
            //         ...Array(Math.max(0, 5 - response?.data?.result?.products?.length)).fill(this.state.placeholderItem),
            //     ];
            // }
            this.setState({getTop5Products: response?.data?.data?.slice(0, 5)}, () => this.setState({top5Loading: false}));
        }).catch((error) => {
            HelperGeneral.alert(error);
            this.setState({top5Loading: false});
        });
    }

    bestSeller = () => {
        Api.bestSeller().then((response) => {
            // if (response?.data?.data && response?.data?.data?.length > 0) {
            //     response.data.data.products = [
            //         ...response?.data?.data,
            //         ...Array(Math.max(0, 5 - response?.data?.data?.length)).fill(this.state.placeholderItem),
            //     ];
            // }
            this.setState({getTop5SellerProducts: response?.data?.data?.slice(0, 5)}, () => this.setState({top5Loading: false}));
        }).catch((error) => {
            HelperGeneral.alert(error);
            this.setState({top5Loading: false});
        });
    }

    top5HTML = (type = 1) => {
        const {getTop5Products, getTop5SellerProducts} = this.state;

        const temp = type === 1 ? getTop5Products : getTop5SellerProducts;

        function tempFunc(a, i) {
            const v = a?.product;
            return '<div class="product" key="' + (i + 5) + '">' + '<div class="number">' + (i + 1) + '</div><div class="img"><a title="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '" href="' + (v?.id ? '/urunler/' + v?.id : '#') + '"><img src="' + (v?.image && v?.image?.length > 0 ? v?.image : require('../../../assets/images/png/default-product.png')) + '" alt="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '"/></a>' +
                '</div><div class="details"><div class="title"><a title="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '" href="' + (v?.id ? '/urunler/' + v?.id : '#') + '">' + HelperGeneral.strShort((v?.name && v?.name?.length > 0 ? v?.name : '-'), 36) + '</a></div><div class="desc">' + HelperGeneral.strShort((v?.code ?? '-'), 50) + '</div>' +
                '<div class="' + (v?.name !== '-' ? 'stars score-5' : 'stars score-0') + '"><span></span><span></span><span></span><span></span><span></span></div></div></div>';
        }

        let content = '';
        content += '<div class="left">';
        let y = temp?.length > 0 ? temp?.map(function (a, i) {
            const v = a?.product;
            if (i == 0) {
                content += '<div class="product" key="' + (i + 10) + '">' + '<div class="img"><a title="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '" href="' + (v?.id ? '/urunler/' + v?.id : '#') + '"><img src="' + (v?.image && v?.image?.length > 0 ? v?.image : require('../../../assets/images/png/default-product.png')) + '" alt="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '"/></a>' +
                    '</div><div class="details"><div class="number">' + (i + 1) + '</div><div class="title"><a title="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '" href="' + (v?.id ? '/urunler/' + v?.id : '#') + '">' + HelperGeneral.strShort((v?.name && v?.name?.length > 0 ? v?.name : '-'), 33) + '</a></div><div class="desc">' + HelperGeneral.strShort((v?.code ?? '-'), 50) + '</div>' +
                    '<div class="' + (v?.name !== '-' ? 'stars score-5' : 'stars score-0') + '"><span></span><span></span><span></span><span></span><span></span></div></div></div>';
            }
        }) : null;
        content += '</div>';
        content += '<div class="right">';
        let x = temp?.length > 0 ? temp?.map(function (v, i) {
            if (i > 0) {
                content += tempFunc(v, i);
            }
        }) : null;
        content += '</div>';
        return ReactHtmlParser(content);
    }

    render() {
        const {
            width,
            sliders,
            activeKey,
            pointModal,
            lastLookedItem,
            lastLookedItemLoading,
            top5Loading,
            getTop5Products,
            getTop5SellerProducts,
            sliderLoading
        } = this.state;

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animation,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
            },
        };

        const itemCount = Array.isArray(lastLookedItem) ? lastLookedItem?.length : 0;
        const slides = (max) => {
            if (itemCount === 1) return 2;
            return Math.min(itemCount || max, max);
        };
        const showArrows = (min) => itemCount >= min;
        const settings = {
            slidesToShow: slides(4),
            slidesToScroll: slides(4),
            arrows: showArrows(5),
            autoplay: false,
            autoplaySpeed: 5000,
            infinite: false,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: slides(3),
                        slidesToScroll: slides(3),
                        arrows: showArrows(4),
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: showArrows(3),
                    }
                },
                {
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: showArrows(2),
                    }
                }
            ]
        };

        const lottieLoading = () => (
            <div className="position-absolute w-100 h-100" style={{pointerEvents: "none"}}>
                <Lottie options={defaultOptions}/>
            </div>
        );

        return (
            <Container className={'home-page home-consumer-page home-page-p'}>
                <Row className={'mt-4 rounded'}>
                    <Col xs={12} xl={9} className={'carousel-col'}>
                        <Spin spinning={sliderLoading} className={'h-100'}>
                            <Carousel
                                className={'carousel'}
                                nextIcon={<FontAwesomeIcon icon={faAngleRight} style={{color: 'black', fontSize: 20}}/>}
                                prevIcon={<FontAwesomeIcon icon={faAngleLeft} style={{color: 'black', fontSize: 20}}/>}
                                touch={true}
                                controls={width > 991}
                                indicators={width > 991}
                            >
                                {
                                    sliders?.map((v, i) => (
                                        <Carousel.Item key={i} className={'h-100'}>
                                            <a
                                                href={'#'}
                                                onClick={() => {
                                                    try {
                                                        if (typeof window.soulTrackEvent === 'function') {
                                                            window.soulTrackEvent({
                                                                eventName: 'select_promotion',
                                                                ecommerce: {
                                                                    creative_slot: `Home Page - Slider - ${i + 1}`,
                                                                    promotion_id: String(v?.id ?? i + 1),
                                                                    promotion_name: v?.title || v?.name || `slider_${i + 1}`,
                                                                    promotion_image: v?.image_urls?.image?.raw ?? v?.image_urls?.image?.w750x,
                                                                    promotion_position: i + 1,
                                                                },
                                                            });
                                                        }
                                                    } catch (e) {
                                                        // best-effort
                                                    }
                                                    if (v?.category && v?.category?.info && v?.category?.info?.slug) {
                                                        HelperGeneral.pageChange(this, '/kategori/' + v?.category?.info?.slug)
                                                    } else {
                                                        HelperGeneral.pageChange(this, '/kategori/daily/temel-bakim')
                                                    }
                                                }}
                                            >
                                                <img
                                                    className={'d-block w-100 h-100'}
                                                    style={{objectFit: 'cover'}}
                                                    src={v?.image_urls?.image?.raw ?? v?.image_urls?.image?.w750x}
                                                    alt={i}
                                                />
                                            </a>
                                        </Carousel.Item>
                                    ))
                                }
                            </Carousel>
                        </Spin>
                    </Col>
                    <Col md={12} xl={3}>
                        <div className={'gift-box h-100 rounded pb-0 position-relative'} style={{minHeight: '311px'}}>
                            {lottieLoading()}
                            <Container className={'point-container'}>
                                <Row className={'pt-3 position-relative'} style={{zIndex: 1}}>
                                    <Col xs={(UserInfo.info('user_roles_id') === 4 || UserInfo.info('user_roles_id') === 6) ? 12 : 8} className={"mx-auto d-flex align-items-center justify-content-center text-center mb-2 gap-3"}>
                                        <div className={"point"}>
                                            <div className={"point-circle shadow"} style={(UserInfo.info('user_roles_id') === 4 || UserInfo.info('user_roles_id') === 6) ? {left: 0} : {}}>
                                                <Container className={'h-100'}>
                                                    <Row className={"h-100"}>
                                                        <Col xs={12} className={"d-flex align-items-end justify-content-center"}>
                                                            <h1>
                                                                {UserInfo.info('score') ?? '0'}
                                                            </h1>
                                                        </Col>
                                                        <Col xs={12} className={"d-flex align-items-start justify-content-center"}>
                                                            <img
                                                                src={require('../../../assets/images/png/theme/q-point-logo.png')}
                                                                className={'q-point-logo'}
                                                                alt={'q-point-logo'}
                                                            />
                                                            <span className={'mt-1'}>Puan</span>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </div>
                                        </div>
                                        {/*
                                            (UserInfo.info('user_roles_id') === 4 || UserInfo.info('user_roles_id') === 6) && (
                                                <div className={"point"}>
                                                    <div className={"point-circle shadow"} style={{left: 0}}>
                                                        <Container className={'h-100'}>
                                                            <Row className={"h-100"}>
                                                                <Col xs={12} className={"d-flex align-items-end justify-content-center"}>
                                                                    <h1>
                                                                        {UserInfo.info('point_money_value') ?? '-'}
                                                                    </h1>
                                                                </Col>
                                                                <Col xs={12} className={"d-flex align-items-start justify-content-center"}>
                                                                    <span className={'mt-1'}>{UserInfo.info('point_money_currency_label') ?? 'TL'}</span>
                                                                </Col>
                                                            </Row>
                                                        </Container>
                                                    </div>
                                                </div>
                                            )
                                        */}
                                    </Col>
                                    <Col xs={12} className={'d-flex align-items-center justify-content-center text-center mb-1 text-black'} style={{fontSize: 20}}>
                                        {UserInfo.fullUserName()}
                                    </Col>
                                    <Col xs={12} className={'d-flex align-items-center justify-content-center text-center mb-1'} style={{fontSize: 14}}>
                                        <a
                                            href={'/my-account/info'}
                                            target={'_blank'}
                                            className={'text-black profile-btn'}
                                        >
                                            Profilini Görüntüle
                                        </a>
                                    </Col>
                                    {/*<Col xs={12} className={'d-flex align-items-center justify-content-center text-center mb-3'}>*/}
                                    {/*    <a*/}
                                    {/*        className={'text-black btn'}*/}
                                    {/*        onClick={() => {*/}
                                    {/*            this.setState({pointModal: true});*/}
                                    {/*        }}*/}
                                    {/*    >*/}
                                    {/*        Puan Özetini Görüntüle*/}
                                    {/*    </a>*/}
                                    {/*</Col>*/}
                                </Row>
                            </Container>
                        </div>
                    </Col>
                    <Modal
                        visible={pointModal}
                        width={1100}
                        footer={false}
                        onOk={() => {
                            this.setState({pointModal: true});
                        }}
                        onCancel={() => {
                            this.setState({pointModal: false});
                        }}
                    >
                        <ReportDashboard/>
                    </Modal>
                </Row>
                <Tabs
                    onChange={(activeKey) => this.setState({activeKey: activeKey})}
                    activeKey={activeKey}
                    moreIcon={null}
                >
                    <Tabs.TabPane tab={""} key={"1"} active={true}>
                        <EarnPoints getTop5Products={this.getTop5Products}/>
                    </Tabs.TabPane>
                    {/*<Tabs.TabPane tab="Hediye Ürün Ver" key="2">*/}
                    {/*    <GiveGift*/}
                    {/*        activeKey={activeKey}*/}
                    {/*        sendCompletedGiftOperation={(key) => {*/}
                    {/*            this.setState({activeKey: key});*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</Tabs.TabPane>*/}
                </Tabs>
                <Spin spinning={top5Loading}>
                    <section className="three-block-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 area-col">
                                    <div className={getTop5SellerProducts?.length > 0 ? "box top-products type1" : "box top-products type1 empty"}>
                                        <div className="box-head">
                                            <div className="title">En Çok Satanlar</div>
                                        </div>
                                        <div className="box-content">
                                            <div className="top-products">
                                                {
                                                    getTop5SellerProducts?.length > 0 ? (
                                                        this.top5HTML(2)
                                                    ) : (
                                                        !top5Loading && (
                                                            <Empty description={'Top 5 Ürün Bulunamadı.'}/>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 area-col">
                                    <div className={getTop5Products?.length > 0 ? "box top-products type2" : "box top-products type2 empty"}>
                                        <div className="box-head">
                                            <div className="title">En Çok Puan Kazandıranlar</div>
                                        </div>
                                        <div className="box-content">
                                            <div className="top-products">
                                                {
                                                    getTop5Products?.length > 0 ? (
                                                        this.top5HTML(1)
                                                    ) : (
                                                        !top5Loading && (
                                                            <Empty description={'Top 5 Ürün Bulunamadı'}/>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Spin>
                <Spin spinning={lastLookedItemLoading}>
                    <Container className={'d-flex justify-content-center last-looked-container mt-4 mt-sm-2'}>
                        <Row className={'slider-row-container'}>
                            <Col xs={12}>
                                <h3>Son Bakılan Ürünler</h3>
                            </Col>
                            <Col>
                                {
                                    lastLookedItem?.length !== 0 && !lastLookedItemLoading > 0 ? (
                                        <Slider {...settings}>
                                            {
                                                lastLookedItem?.map((v) => {
                                                    return (
                                                        <div key={v?.id} className={'custom-slider-items-container'}>
                                                            <div className={'large-image'}>
                                                                <Link to={'/product/' + v?.slug} onClick={() => HelperGeneral.addToLastLookedItem(v, 2)}>
                                                                    <img src={v?.images?.[0]?.w250x ?? require('../../../assets/images/png/default-product.png')}/>
                                                                </Link>
                                                            </div>
                                                            <div className={'custom-title'} style={{maxHeight: `${3 * 1.1}em`}}>
                                                                <Link to={'/product/' + v?.slug} className={'title-style'} onClick={() => HelperGeneral.addToLastLookedItem(v, 2)}>
                                                                    {v?.name ?? '-'}
                                                                </Link>
                                                            </div>
                                                            <div className={'reward-section'} style={{visibility: (v?.earn_points > 0) ? 'visible' : 'hidden'}}>
                                                                <span className={'reward-point'}>{HelperGeneral.formatPoint(v?.earn_points)}</span>
                                                                <img
                                                                    className={'reward-section-img'}
                                                                    src={require('../../../assets/images/png/theme/q-point-logo.png')}
                                                                />
                                                            </div>
                                                            <div className={'examine-section'}>
                                                                <Link className={'link'} to={'/product/' + v?.slug} onClick={() => HelperGeneral.addToLastLookedItem(v, 2)}>
                                                                    <span><FontAwesomeIcon icon={faSearch}/> İncele</span>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Slider>
                                    ) : (
                                        !lastLookedItemLoading && (
                                            <div className={'pt-4'}>
                                                <Empty description={'Son bakılan ürün bulunmamaktadır'}/>
                                            </div>
                                        )
                                    )
                                }
                            </Col>
                        </Row>
                    </Container>
                </Spin>
            </Container>
        );
    }
}

export default withRouter(Home);
